import { DivCard } from "../../models/item-data-models";

export const divinationCardsDataManual: DivCard[] = [
];
